import React from "react";
import "../../../styles/CustomButton.css";

function CustomButton({
  onClick,
  children,
  style = {},
  className = "",
  onMouseEnter,
  onMouseLeave,
  ...otherProps
}) {
  const buttonClasses = `custom-button fixed-width ${className}`.trim();

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...otherProps}
    >
      <div className="custom-button-content">{children}</div>
    </button>
  );
}

export default CustomButton;
